import $ from 'jquery';
import './domEnhance';

// 获取函数的函数名, 为了兼容IE8
function functionName(fun) {
    let ret = fun.toString();
    ret = ret.substr('function '.length);
    ret = ret.substr(0, ret.indexOf('('));
    return ret;
}

class Sloth {
    constructor() {
        this.selector = 'component';
        this.components = [];
    }

    init() {
        $(`[${this.selector}]`).each((index, dom) => {
            const moduleName = $(dom).attr(this.selector);
            const Component = this.getComponent(moduleName);

            this.initDom(dom, Component);
        });
    }

    initDom(dom, Component) {
        if (typeof dom.component === 'object') {
            return;
        } // 防止重复初始化组件
        if (!Component) {
            return;
        } // 未找到对应组件

        const instance = new Component();
        instance.dom = dom;
        instance.options = Object.assign({}, Component.defaultOptions, $(dom).options());
        instance.onInit();
        dom.component = instance;
    }

    // Decorator
    component(options) {
        return (component) => {
            component.defaultOptions = options.defaultOptions;
            this.addComponent(component);
        };
    }

    addComponent(component) {
        component.componentName = functionName(component);
        this.components.push(component);
    }

    getComponent(componentName) {
        for (let i = 0; i < this.components.length; i++) {
            if (this.components[i].componentName === componentName) {
                return this.components[i];
            }
        }
    }

    removeComponent(componentName) {
        for (let i = 0; i < this.components.length; i++) {
            if (this.components[i].componentName === componentName) {
                this.components.splice(i, 1);
            }
        }
    }

    isMobile() {
        return document.body.clientWidth < 960;
    }
}

export default new Sloth();



/** WEBPACK FOOTER **
 ** ./components/Sloth/sloth.js
 **/